import React from "react"
import { Row, Container, Col } from "react-bootstrap"
import { AdSide1, AdSide2, AdFooter } from '../components/ads'

const BlogPost = ({ children, title }) => {

  return (
      <Container>
      <Row>
        <Col xs={12} md={8}>
        <div className="d-flex justify-content-center">
        <h1 itemProp="headline">{title}</h1>
        </div>
          <article
            className="blog-post"
            itemScope
            itemType="http://schema.org/Article"
          >
            {children}
          </article>
        </Col>
        <Col md={4}>
          <div className="ad_vertical">
          <AdSide1 />
          </div><br/>
          <div className="ad_vertical mb-4">
          <AdSide2 />
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
        <div className="ad_horizontal mb-4">
        <AdFooter />
        </div>
        </Col>
      </Row>
      </Container>
  )
}

export default BlogPost

